// extracted by mini-css-extract-plugin
export default {"title":"app-assets-javascripts-components-pageTitle-pageTitle__title--X33wr"};